var map = {
	"./Svgs": 177,
	"./Svgs/": 177,
	"./Svgs/bookmark_icon.svg": 1315,
	"./Svgs/caret_down_filled.svg": 1316,
	"./Svgs/caret_up_down.svg": 1317,
	"./Svgs/caret_up_filled.svg": 1318,
	"./Svgs/circle_check.svg": 1319,
	"./Svgs/closeCircle.svg": 1320,
	"./Svgs/default_coverimage.svg": 967,
	"./Svgs/delete.svg": 1321,
	"./Svgs/desktop_frame.svg": 1322,
	"./Svgs/grid_view.svg": 1323,
	"./Svgs/ic_InfoCircle_fill.svg": 1324,
	"./Svgs/ic_alian.svg": 1325,
	"./Svgs/ic_align_center.svg": 1326,
	"./Svgs/ic_align_left.svg": 1327,
	"./Svgs/ic_align_right.svg": 1328,
	"./Svgs/ic_bold.svg": 1329,
	"./Svgs/ic_bug.svg": 1330,
	"./Svgs/ic_calender.svg": 1331,
	"./Svgs/ic_caution.svg": 1332,
	"./Svgs/ic_check.svg": 1333,
	"./Svgs/ic_circle_sucess_check.svg": 1334,
	"./Svgs/ic_cockpit.svg": 1335,
	"./Svgs/ic_code.svg": 1336,
	"./Svgs/ic_curl_command_error.svg": 1337,
	"./Svgs/ic_danger_dark.svg": 1338,
	"./Svgs/ic_desktop.svg": 1339,
	"./Svgs/ic_double_left_arrow.svg": 1340,
	"./Svgs/ic_download.svg": 1341,
	"./Svgs/ic_edit.svg": 1342,
	"./Svgs/ic_empty.svg": 1343,
	"./Svgs/ic_engine.svg": 1344,
	"./Svgs/ic_error.svg": 1345,
	"./Svgs/ic_excel.svg": 1346,
	"./Svgs/ic_expand.svg": 1347,
	"./Svgs/ic_folder_default.svg": 1348,
	"./Svgs/ic_folder_open.svg": 1349,
	"./Svgs/ic_fontcolor.svg": 1350,
	"./Svgs/ic_fontsize.svg": 1351,
	"./Svgs/ic_full_screen_exit.svg": 1352,
	"./Svgs/ic_full_screen_expand.svg": 1353,
	"./Svgs/ic_html.svg": 1354,
	"./Svgs/ic_image.svg": 1355,
	"./Svgs/ic_info.svg": 1356,
	"./Svgs/ic_info_circle_outlined.svg": 1357,
	"./Svgs/ic_italic.svg": 1358,
	"./Svgs/ic_language.svg": 1359,
	"./Svgs/ic_left.svg": 1360,
	"./Svgs/ic_link.svg": 1361,
	"./Svgs/ic_link_url.svg": 968,
	"./Svgs/ic_logout.svg": 1362,
	"./Svgs/ic_modal_open.svg": 1363,
	"./Svgs/ic_orderedlist.svg": 1364,
	"./Svgs/ic_pdf.svg": 1365,
	"./Svgs/ic_pencil.svg": 1366,
	"./Svgs/ic_plus_column.svg": 1367,
	"./Svgs/ic_powerpoint.svg": 1368,
	"./Svgs/ic_preview.svg": 1369,
	"./Svgs/ic_product_st_archive.svg": 1370,
	"./Svgs/ic_product_st_design.svg": 1371,
	"./Svgs/ic_product_st_production.svg": 1372,
	"./Svgs/ic_question_circle.svg": 1373,
	"./Svgs/ic_reduce.svg": 1374,
	"./Svgs/ic_refresh.svg": 1375,
	"./Svgs/ic_right.svg": 1376,
	"./Svgs/ic_search.svg": 1377,
	"./Svgs/ic_sidemenu_calculations.svg": 1378,
	"./Svgs/ic_sidemenu_catalogue.svg": 1379,
	"./Svgs/ic_sidemenu_product.svg": 1380,
	"./Svgs/ic_sidemenu_testing.svg": 1381,
	"./Svgs/ic_star.svg": 1382,
	"./Svgs/ic_status_archive_outlined.svg": 1383,
	"./Svgs/ic_status_design_outlined.svg": 1384,
	"./Svgs/ic_status_production_outlined.svg": 1385,
	"./Svgs/ic_success_checked.svg": 1386,
	"./Svgs/ic_sync.svg": 1387,
	"./Svgs/ic_table_down_caret.svg": 1388,
	"./Svgs/ic_table_up_caret.svg": 1389,
	"./Svgs/ic_tablet.svg": 1390,
	"./Svgs/ic_tester.svg": 1391,
	"./Svgs/ic_tutorial.svg": 1392,
	"./Svgs/ic_underline.svg": 1393,
	"./Svgs/ic_undo.svg": 1394,
	"./Svgs/ic_unlink_url.svg": 969,
	"./Svgs/ic_unorderedlist.svg": 1395,
	"./Svgs/ic_view_eye.svg": 1396,
	"./Svgs/ic_warning.svg": 1397,
	"./Svgs/ic_word.svg": 1398,
	"./Svgs/icon_support.svg": 1399,
	"./Svgs/index": 177,
	"./Svgs/index.tsx": 177,
	"./Svgs/left-arrow.svg": 1400,
	"./Svgs/list_view.svg": 1401,
	"./Svgs/phone_frame.svg": 1402,
	"./Svgs/plus_circular.svg": 1403,
	"./Svgs/plus_circular_outlined.svg": 1404,
	"./Svgs/service_doc_icon.svg": 1405,
	"./Svgs/six_dot_icon.svg": 1406,
	"./Svgs/tablet_frame.svg": 1407,
	"./Svgs/testing_centre_icon.svg": 1408,
	"./Svgs/version_overview_icon.svg": 1409,
	"./Svgs/view_logs_icon.svg": 1410,
	"./Svgs/warning_icon.svg": 1411,
	"./Svgs/warning_icon_red.svg": 1412,
	"./aia.dev.idp.configuration": 682,
	"./aia.dev.idp.configuration.json": 682,
	"./aia.production.idp.configuration": 683,
	"./aia.production.idp.configuration.json": 683,
	"./aia.staging.idp.configuration": 684,
	"./aia.staging.idp.configuration.json": 684,
	"./bolttech.dev.idp.configuration": 685,
	"./bolttech.dev.idp.configuration.json": 685,
	"./bolttech.prod.idp.configuration": 686,
	"./bolttech.prod.idp.configuration.json": 686,
	"./bolttech.uat.idp.configuration": 687,
	"./bolttech.uat.idp.configuration.json": 687,
	"./chubb-th.idp.configuration": 688,
	"./chubb-th.idp.configuration.json": 688,
	"./chubb-th.stg.idp.configuration": 689,
	"./chubb-th.stg.idp.configuration.json": 689,
	"./chubb.dev.idp.configuration": 690,
	"./chubb.dev.idp.configuration.json": 690,
	"./chubb.idp.configuration": 691,
	"./chubb.idp.configuration.json": 691,
	"./chubb.prod.idp.configuration": 692,
	"./chubb.prod.idp.configuration.json": 692,
	"./chubb.stg.idp.configuration": 693,
	"./chubb.stg.idp.configuration.json": 693,
	"./dev.global.idp.configuration": 694,
	"./dev.global.idp.configuration.json": 694,
	"./dev.idp.configuration": 695,
	"./dev.idp.configuration.json": 695,
	"./logo-animation": 329,
	"./logo-animation.json": 329,
	"./pob.sit.idp.configuration": 696,
	"./pob.sit.idp.configuration.json": 696,
	"./poc.dev.idp.configuration": 697,
	"./poc.dev.idp.configuration.json": 697,
	"./pocklm.dev.idp.configuration": 698,
	"./pocklm.dev.idp.configuration.json": 698,
	"./qa.global.idp.configuration": 699,
	"./qa.global.idp.configuration.json": 699,
	"./qms.dev.idp.configuration": 700,
	"./qms.dev.idp.configuration.json": 700,
	"./qms.qa.idp.configuration": 701,
	"./qms.qa.idp.configuration.json": 701,
	"./qms.sit.idp.configuration": 702,
	"./qms.sit.idp.configuration.json": 702,
	"./scbl.dev.idp.configuration": 703,
	"./scbl.dev.idp.configuration.json": 703,
	"./scbl.prod.idp.configuration": 704,
	"./scbl.prod.idp.configuration.json": 704,
	"./scbl.sit.idp.configuration": 705,
	"./scbl.sit.idp.configuration.json": 705,
	"./scbl.stg.idp.configuration": 706,
	"./scbl.stg.idp.configuration.json": 706,
	"./scbl.uat.idp.configuration": 707,
	"./scbl.uat.idp.configuration.json": 707,
	"./stg.idp.configuration": 708,
	"./stg.idp.configuration.json": 708,
	"./uat.jp.idp.configuration": 709,
	"./uat.jp.idp.configuration.json": 709,
	"./uat.us.idp.configuration": 710,
	"./uat.us.idp.configuration.json": 710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1314;